var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0779 4.50136C13.2368 4.34241 13.4255 4.21632 13.6332 4.1303C13.8409 4.04428 14.0635 4 14.2883 4C14.513 4 14.7356 4.04428 14.9433 4.1303C15.151 4.21632 15.3397 4.34241 15.4986 4.50136C15.6576 4.66031 15.7837 4.84901 15.8697 5.05669C15.9557 5.26436 16 5.48695 16 5.71174C16 5.93653 15.9557 6.15912 15.8697 6.3668C15.7837 6.57447 15.6576 6.76317 15.4986 6.92212L7.32855 15.0922L4 16L4.90779 12.6714L13.0779 4.50136Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.72741f51b513feebb0de0e7de64ae375.svg";
export { ForwardRef as ReactComponent };